import { createResponseTransformer } from "shared/api/createResponseTransformer"

export const kpiDashboardResponseTransformer = createResponseTransformer(
  json => json
)
